const toTitleCase = (str) => {
  if (!str) {
    return '';
  }
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default toTitleCase;
